<div class="overlay" data-testid="paused-overlay">
  <div class="panel">
    <h2>CheckPoint is paused in this tab</h2>
    <p>Another tab is currently active. Click below to use CheckPoint in this tab instead.</p>
    <button (click)="requestLeadership()" data-testid="activate-tab-button">Use this tab</button>
  </div>
</div>